import getFirstDayOfWeek from './getFirstDayOfWeek';

export default function isFirstDayOfWeek(day) {
  return day.weekday === getFirstDayOfWeek();
}
